module.exports = __webpack_public_path__ + "static/media/SPG_QR_WH.ca75822a.svg";